import CustomScrollbar from 'components/Common/CustomScrollbar';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import DashboardListComponent from 'components/Dashboard/DashboardComponent/DashboardListComponent';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { store } from 'components/Store';
import time from 'utils/time';
import dayjs from 'dayjs';
import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import LocalStorage from 'utils/LocalStorage';

const FirstBriefingMessage = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team, keywordsLists } = state;

  const { tailorSummaryState, initialCall } = props ?? {};
  const { setShowTailorSummaryModal } = tailorSummaryState ?? {};

  const isGenerating = LocalStorage.getItem('firstBriefingGenerating') === 'true';
  const [isLoading, setIsLoading] = useState(isGenerating);

  const keywordsListsToUse = keywordsLists?.filter((item) => item?.id !== null);

  const { generalApiCall } = useGeneralApiCall();

  const generateBriefing = async () => {
    try {
      setIsLoading(true);
      const pathname = `/api/briefings/generate-briefing`;
      const requestProperties = {
        date: dayjs()?.format('YYYY-MM-DD'),
        teamId: team?.teamId,
      };
      const results = await generalApiCall({
        pathname,
        method: 'post',
        requestProperties,
        needsAuthentication: true,
        notShowErrorMessage: true,
        returnCompleteRequest: true,
        returnError: true,
      });
      if (results?.status === 200) {
        await initialCall.current({ newCall: true });
      } else {
        createNotification('danger', !!results?.data ? results?.data : 'An error ocurred.');
        setIsLoading(false);
      }
    } catch (error) {
      createNotification('danger', error);
      setIsLoading(false);
    }
  };

  const processingBriefing = isLoading;
  return (
    <div className='px-4 px-lg-0'>
      <div className='d-none d-lg-flex'>
        <div className='col-lg-8 px-0 pr-lg-3'>
          <BriefingDescriptionTitle />
        </div>
        <div className='col-lg-8 px-0 pl-lg-3 d-flex flex-column'>
          <div className='pt-4 pt-lg-0'>
            <BriefingsTopicTitle />
          </div>
        </div>
      </div>
      <div className='d-lg-flex'>
        <div className='col-lg-8 px-0 pr-lg-3'>
          <div className='d-lg-none'>
            <BriefingDescriptionTitle />
          </div>

          <div
            className={`position-relative bg-blue-hovered rounded border px-4 py-3 briefing-description-container ${
              processingBriefing ? '' : 'pointer'
            }`}
            onClick={() => {
              if (!processingBriefing) {
                setShowTailorSummaryModal(true);
              }
            }}
            style={{ minHeight: '130px' }}
          >
            <button
              className={`circle-button circle-button-32  text-white general-button position-absolute briefing-action-button bg-main-blue  ${
                processingBriefing ? 'disabled' : ''
              }`}
              style={{ right: '-14px', top: '-14px' }}
              disabled={processingBriefing}
            >
              <span className='icon-edit-pencil paragraph-p2' />
            </button>

            <p className=' light-60-text mb-0  hidden-lines hidden-four-lines'>{team?.organisationDescription}</p>
          </div>
        </div>

        <div className='col-lg-8 px-0 pl-lg-3 d-flex flex-column'>
          <div className='pt-4 pt-lg-0 d-lg-none'>
            <BriefingsTopicTitle />
          </div>

          <div className='rounded border flex-grow-1 briefing-first-message-topics'>
            <CustomScrollbar className='simple-scrollbar'>
              <div className='specific-y-padding-8'>
                <DashboardListComponent path={'first-briefing'} disabledCondition={processingBriefing} />
                <div className='px-3 specific-y-padding-6 list-action-button'>
                  <Link to={'/settings/topics/new-topic'} className='text-light-blue general-link d-block'>
                    <span
                      className='title-h2 d-inline-block-centered centered-7 specific-right-margin-11 specific-left-margin-3'
                      style={{ lineHeight: 1 }}
                    >
                      +
                    </span>{' '}
                    {keywordsLists?.length === 0 ? 'Create a topic' : 'Add a topic'}
                  </Link>
                </div>
              </div>
            </CustomScrollbar>
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-end pt-5 pb-4'>
        <button
          className='general-button action-button specific-x-padding-32 py-2 rounded-pill w-100'
          disabled={keywordsListsToUse?.filter((item) => item?.includedForBriefings)?.length === 0 || isLoading}
          onClick={generateBriefing}
        >
          {isLoading && <i className='fas fa-spinner fa-spin mx-2 d-inline-block-centered' />}
          {isLoading ? 'Generating briefing - this may take a minute or two' : 'Generate briefing'}
        </button>
      </div>
    </div>
  );
};

const BriefingsTopicTitle = () => {
  return (
    <>
      <h3 className='title-h5-m-bold mb-1'>Topics included in your briefings</h3>
      <p className='light-60-text mb-3'>Choose the topics that feed updates into your briefings</p>
    </>
  );
};

const BriefingDescriptionTitle = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;
  const { organisationDescriptionLastModified, organisationDescriptionAuthorFullName } = team ?? {};

  return (
    <>
      <h3 className='title-h5-m-bold mb-1'>Organisation description</h3>
      <p className='light-60-text mb-3'>
        {!!organisationDescriptionLastModified && !!organisationDescriptionAuthorFullName
          ? `Last edited on ${time(organisationDescriptionLastModified).formatLongDate(true)}`
          : 'This has been created using generative AI'}
      </p>
    </>
  );
};

export default FirstBriefingMessage;
